<template>
  <v-row class="app-preview">
    <v-col
      cols="12"
      md="9"
    >
      <v-card class="app-broker-editable">
        <!-- Header -->
        <div class="py-5 px-5">
          <div class="d-flex flex-wrap justify-space-between">
            <!-- Date -->
            <div class="d-flex align-center">
              <span class="me-2 font-weight-medium text--primary">Edit Broker</span>
            </div>
          </div>
        </div>

        <v-divider></v-divider>

        <!-- Customer Details -->
        <div class="py-5 px-5">
          <div class="mb-3 d-flex">
            <div class="px-3 flex-grow-1">
              <v-row>
                <!-- Registration Date -->
                <v-col
                  cols="12"
                  sm="6"
                  :class="{ 'pl-0 mb-6 mb-sm-0': $vuetify.breakpoint.smAndUp, 'px-0': $vuetify.breakpoint.xsOnly }"
                >
                  <p class="font-weight-semibold">
                    Registration Date:
                  </p>
                  <v-menu
                    v-model="isDateMenuOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :append-icon="icons.mdiCalendar"
                        :value="new Date(broker.registration_date).toLocaleDateString()"
                        readonly
                        dense
                        outlined
                        hide-details
                        :disabled="auditorDisabled || voidRequestDisabled || isApprovedRequest"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="broker.registration_date"
                      color="primary"
                      :first-day-of-week="1"
                      @input="isDateMenuOpen = false"
                    >
                    </v-date-picker>
                  </v-menu>
                  <RequestHint
                    v-if="request && !isApprovedRequest"
                    :is-attr-change="broker.registration_date !== request.registration_date"
                    :is-auditor-respond="auditorDisabled"
                    :is-request-void="isRequestVoid"
                    :hint="new Date(request.registration_date).toLocaleDateString('en-SG')"
                  />
                </v-col>
              </v-row>
              <v-row>
                <!-- Name -->
                <v-col
                  cols="12"
                  sm="6"
                  :class="{ 'pl-0 mb-6 mb-sm-0': $vuetify.breakpoint.smAndUp, 'px-0': $vuetify.breakpoint.xsOnly }"
                  class="offset-sm-0"
                >
                  <p class="font-weight-semibold">
                    Broker Name:
                  </p>
                  <v-text-field
                    v-model="broker.name"
                    single-line
                    dense
                    outlined
                    hide-details
                    placeholder="Broker Name"
                    :disabled="auditorDisabled || voidRequestDisabled || isApprovedRequest"
                  ></v-text-field>
                  <RequestHint
                    v-if="request && !isApprovedRequest"
                    :is-attr-change="broker.name !== request.name"
                    :is-auditor-respond="auditorDisabled"
                    :is-request-void="isRequestVoid"
                    :hint="request.name"
                  />
                </v-col>

                <!-- Contact Number -->
                <v-col
                  cols="12"
                  sm="6"
                  :class="{ 'pr-0 mb-6 mb-sm-0': $vuetify.breakpoint.smAndUp, 'px-0': $vuetify.breakpoint.xsOnly }"
                >
                  <p class="font-weight-semibold">
                    Contact No.:
                  </p>
                  <v-text-field
                    v-model="broker.contact_number"
                    single-line
                    dense
                    outlined
                    type="number"
                    :rules="[v => /[0-9\-().\s]{7}$/.test(v) || 'Must be valid contact number']"
                    hide-details="auto"
                    placeholder="Contact Number"
                    prefix="+673"
                    :disabled="auditorDisabled || voidRequestDisabled || isApprovedRequest"
                    @mousewheel.native.prevent
                  ></v-text-field>
                  <RequestHint
                    v-if="request && !isApprovedRequest"
                    :is-attr-change="broker.contact_number !== request.contact_number"
                    :is-auditor-respond="auditorDisabled"
                    :is-request-void="isRequestVoid"
                    :hint="request.contact_number"
                  />
                </v-col>

                <!-- IC Number -->
                <v-col
                  cols="12"
                  sm="6"
                  :class="{ 'pl-0 mb-6 mb-sm-0': $vuetify.breakpoint.smAndUp, 'px-0': $vuetify.breakpoint.xsOnly }"
                >
                  <p class="font-weight-semibold">
                    IC No.:
                  </p>
                  <v-text-field
                    v-model="broker.ic_number"
                    single-line
                    dense
                    outlined
                    hide-details="auto"
                    placeholder="IC Number"
                    :disabled="auditorDisabled || voidRequestDisabled || isApprovedRequest"
                  ></v-text-field>
                  <RequestHint
                    v-if="request && !isApprovedRequest"
                    :is-attr-change="broker.ic_number !== request.ic_number"
                    :is-auditor-respond="auditorDisabled"
                    :is-request-void="isRequestVoid"
                    :hint="request.ic_number"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  v-if="broker.ic_url || request.request_ic_url"
                  cols="12"
                  sm="6"
                  :class="{ 'pl-0 mb-6 mb-sm-0': $vuetify.breakpoint.smAndUp, 'px-0': $vuetify.breakpoint.xsOnly }"
                >
                  <p class="font-weight-semibold mb-0">
                    IC Attachment
                  </p>

                  <div v-if="!broker.ic_url">
                    <small
                      v-if="request.request_ic_url !== 'Not Found'"
                      class="primary--text"
                    >
                      Empty -->
                    </small>
                    <a
                      v-if="request.request_ic_url !== 'Not Found'"
                      :href="request.request_ic_url"
                      target="_blank"
                      class="font-weight-semibold"
                    >
                      <small>{{ request.request_ic_name }}</small>
                      <v-icon
                        size="18"
                        color="primary"
                      >{{ icons.mdiOpenInNew }}</v-icon>
                    </a>
                    <div v-else>
                      <small class="error--text">
                        Requested attachment seems to be missing or corrupted, please ask counter to reattach again
                      </small>
                    </div>
                  </div>

                  <div v-else>
                    <a
                      :href="broker.ic_url"
                      target="_blank"
                    >
                      <small>{{ broker.ic_name }}</small>
                      <v-icon
                        size="18"
                        color="primary"
                      >{{ icons.mdiOpenInNew }}</v-icon>
                    </a>
                    <div v-if="request.request_ic_url !== 'Not Found'">
                      <RequestHint
                        v-if="request && request.request_ic_url && !isApprovedRequest"
                        :is-attr-change="broker.ic !== request.ic"
                        :is-auditor-respond="auditorDisabled"
                        :is-request-void="isRequestVoid"
                        :hint="request.request_ic_name"
                        :link="request.request_ic_url"
                      />
                    </div>
                    <div v-else>
                      <small v-if="!isRequestCreate" class="error--text">
                        Requested attachment seems to be missing or corrupted, please ask counter to reattach again
                      </small>
                    </div>
                  </div>

                  <v-file-input
                    v-if="!(auditorDisabled || voidRequestDisabled || isApprovedRequest)"
                    v-model="newIc"
                    prepend-icon=""
                    :append-icon="icons.mdiPaperclip"
                    accept="application/pdf, image/png, image/jpg, image/jpeg"
                    show-size
                    dense
                    outlined
                    :rules="icUploadRules"
                    :label="broker.ic_url ? 'Upload new IC' : 'Upload IC'"
                    hide-details="auto"
                    class="mt-4"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip
                        small
                        label
                        color="primary"
                      >
                        {{ text }}
                      </v-chip>
                    </template>

                    <template v-slot:append>
                      <v-progress-circular
                        v-if="uploadLoading"
                        color="primary"
                        indeterminate
                        size="25"
                      ></v-progress-circular>
                    </template>
                  </v-file-input>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      md="3"
    >
      <v-card
        v-if="!isApprovedRequest"
        class="mb-6"
      >
        <v-card-text>
          <!-- Auditor view request -->
          <v-btn
            v-if="can('write', 'ReportActions') && requestId"
            color="primary"
            block
            depressed
            :disabled="isRespondedRequest || broker.deleted_at"
            class="mb-2"
            @click="isApproveDialogVisible = true"
          >
            {{ t('Approve Request') }}
          </v-btn>

          <!-- Auditor view request -->
          <v-btn
            v-if="can('write', 'ReportActions') && requestId"
            color="primary"
            outlined
            depressed
            block
            :disabled="isRespondedRequest"
            @click="isRejectDialogVisible = true"
          >
            {{ t('Reject Request') }}
          </v-btn>

          <!-- Create & edit receipt -->
          <v-btn
            v-else-if="can('write', 'ReportActions') && userRole === 'Auditor'"
            color="primary"
            depressed
            block
            :loading="loading"
            :disabled="loading"
            @click="handleUploads('auditor')"
          >
            {{ t('Confirm Broker') }}
          </v-btn>

          <!-- Void request -->
          <v-btn
            v-else-if="router.currentRoute.params.action === 'Void' || broker.deleted_at"
            color="error"
            depressed
            block
            :disabled="isApprovedRequest"
            @click="isVoidDialogVisible = true"
          >
            {{ t('Remove Request') }}
          </v-btn>

          <!-- Create & edit request -->
          <v-btn
            v-else
            color="primary"
            depressed
            block
            :disabled="isApprovedRequest"
            @click="isCommentDialogVisible = true"
          >
            {{ t('Send Request') }}
          </v-btn>

          <div
            v-if="broker.deleted_at"
            class="text-center mt-4"
          >
            {{ can('write', 'ReportActions') ? t('Broker has been voided, please inform requester to remove this request.')
              : t('Broker has been voided, please remove this request as it cannot be saved.') }}
          </div>

          <div
            v-else-if="!auditorDisabled && router.currentRoute.params.action !== 'Void'"
            class="text-center mt-4"
          >
            {{ t('Please ensure that all fields are filled correctly as this record will not be editable after confirming.') }}
          </div>
        </v-card-text>
      </v-card>
      <v-card
        v-if="errors.length != 0"
        class="mb-6"
      >
        <v-card-text>
          <Alert
            :messages="errors"
            color="error"
          ></Alert>
        </v-card-text>
      </v-card>
      <v-card
        v-if="requestId && !isApprovedRequest && can('write', 'ReportActions')"
        class="mb-6"
      >
        <v-card-text v-if="request.requested_by">
          <div v-if="isRequestVoid">
            {{ request.requested_by.nickname }} has requested to void this broker.
          </div>
          <div v-else-if="isRequestCreate">
            {{ request.requested_by.nickname }} has requested to create this broker.
          </div>
          <div v-else>
            <div class="mb-2">
              {{ request.requested_by.nickname }} has requested to edit this broker.
            </div>
            <div>The <span class="primary--text font-weight-semibold">requested changes</span> is hinted below each broker field, ensure these changes are appropriate as this broker will not be reversible after approval.</div>
          </div>
        </v-card-text>
      </v-card>
      <v-card
        v-if="isApprovedRequest"
        class="mb-6"
      >
        <v-card-text>
          <div>
            This request has been approved & no longer editable.
          </div>
        </v-card-text>
      </v-card>
      <RequestComments
        v-if="requestId"
        :comments="comments"
        :fetch-comments="fetchComments"
      />
    </v-col>

    <!-- Void dialog -->
    <v-dialog
      v-model="isVoidDialogVisible"
      width="500"
    >
      <v-card>
        <v-card-title class="d-flex align-center mv-4">
          Void request on {{ request.record_number || broker.name }}
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isVoidDialogVisible = false"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          This request will be voided. It won't be taken into any calculations.
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="error"
            block
            :loading="voidLoading"
            :disabled="voidLoading"
            class="mt-3"
            @click="voidRequest()"
          >
            Yes, remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Comment dialog -->
    <v-dialog
      v-model="isCommentDialogVisible"
      width="500"
    >
      <v-card>
        <v-card-title class="d-flex align-center mv-4">
          Request changes?
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isCommentDialogVisible = false"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-textarea
            v-model="newComment"
            dense
            outlined
            hide-details="auto"
            placeholder="Leave your comment here (optional)"
            :disabled="loading"
            class="mb-4"
          ></v-textarea>
          <p>
            {{ requestId ? 'This updates the edit request & changes status to Pending for auditor to respond.' :
              'This action will create an edit request & the changes will be saved after approved by auditor.' }}
          </p>
          <p class="mb-0">
            Please leave any remarks that the auditor should know about the changes.
          </p>
        </v-card-text>

        <v-card-actions class="mt-2">
          <v-btn
            color="primary"
            block
            :loading="loading"
            :disabled="loading"
            @click="handleUploads('clerk')"
          >
            Yes, send request
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Approve dialog -->
    <v-dialog
      v-model="isApproveDialogVisible"
      width="500"
    >
      <v-card>
        <v-card-title class="d-flex align-center mv-4">
          Approve request
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isApproveDialogVisible = false"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="newComment"
            dense
            outlined
            hide-details="auto"
            placeholder="Leave your comment here (optional)"
            :disabled="loading"
            class="mb-1"
          ></v-text-field>
          This action will update broker with the request changes, ensure that all fields are filled correctly as this record will not be editable after approval.
        </v-card-text>

        <v-card-actions class="mt-2">
          <v-btn
            color="primary"
            block
            :loading="loading"
            :disabled="loading"
            @click="approveRequest()"
          >
            Save broker
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Reject dialog -->
    <v-dialog
      v-model="isRejectDialogVisible"
      width="500"
    >
      <v-card>
        <v-card-title class="d-flex align-center mv-4">
          Reject request
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isRejectDialogVisible = false"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="newComment"
            dense
            outlined
            hide-details="auto"
            placeholder="Leave your comment here (optional)"
            :disabled="loading"
            class="mb-1"
          ></v-text-field>
          This update the request & change status to Rejected, comment on the reason for rejecting the requested change.
        </v-card-text>

        <v-card-actions class="mt-2">
          <v-btn
            color="primary"
            block
            :loading="loading"
            :disabled="loading"
            @click="rejectRequest()"
          >
            Reject request
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mdiCalendar, mdiPaperclip } from '@mdi/js'
import {
  inject,
  onMounted,
  ref,
} from '@vue/composition-api'
import { useRouter } from '@core/utils'
import Alert from '@/components/Alert'
import RequestHint from '@/components/apps/request/RequestHint'
import RequestComments from '@/components/apps/request/RequestComments'

export default {
  components: {
    Alert,
    RequestHint,
    RequestComments,
  },
  setup() {
    // Initializers
    const store = inject('store')
    const snackbarService = inject('snackbarService')
    const t = inject('t')
    const can = inject('can')
    const { router } = useRouter()
    const requestId = router.currentRoute.params.request_id

    // Properties
    const broker = ref({
      registration_date: new Date().toISOString().substring(0, 10),
      name: null,
      contact_number: null,
      ic_number: null,
      ic: null,
    })
    const request = ref({})
    const comments = ref([])
    const errors = ref([])
    const userData = JSON.parse(localStorage.getItem('userData'))
    const userRole = userData && userData.role ? userData.role : null
    const dateToday = new Date().toLocaleDateString('en-SG')
    const newIc = ref(null)
    const uploadedIc = ref(null)
    const loading = ref(false)
    const voidLoading = ref(false)
    const auditorDisabled = ref(false)
    const voidRequestDisabled = ref(false)
    const isVoidDialogVisible = ref(false)
    const isApproveDialogVisible = ref(false)
    const isRejectDialogVisible = ref(false)
    const isRequestVoid = ref(false)
    const isRequestCreate = ref(false)
    const isApprovedRequest = ref(false)
    const isRespondedRequest = ref(false)
    const isDateMenuOpen = ref(false)
    const isCommentDialogVisible = ref(false)
    const newComment = ref(null)
    const uploadLoading = ref(false)
    const icUploadRules = [value => !value || value.size < 5000000 || 'IC file has to be lower than 5MB']

    // Methods
    const fetchRequest = () => {
      store
        .dispatch('requestStore/fetchRequest', { id: requestId })
        .then(response => {
          let brokerAttrsInField = response.data.data.record
          if (response.data.data.approved_at) {
            isApprovedRequest.value = true
            brokerAttrsInField = response.data.data.result
          }
          const existingBroker = brokerAttrsInField
          broker.value.id = response.data.data.record.id
          broker.value.created_at = existingBroker.created_at
          broker.value.name = existingBroker.name
          broker.value.ic_number = existingBroker.ic_number
          broker.value.contact_number = existingBroker.contact_number
          broker.value.registration_date = new Date(existingBroker.registration_date.replace(/(..)\/(..)\/(....)/, '$3-$2-$1')).toISOString().substring(0, 10)
          if (existingBroker.ic_url) {
            broker.value.ic_url = existingBroker.ic_url
            broker.value.ic_name = existingBroker.ic_name
          }
          if (response.data.data.result) {
            request.value = response.data.data.result
            request.value.registration_date = new Date(request.value.registration_date.replace(/(..)\/(..)\/(....)/, '$3-$2-$1')).toISOString().substring(0, 10)
          }
          request.value.requested_by = response.data.data.requested_by
          request.value.responded_by = response.data.data.responded_by
          request.value.record_number = response.data.data.record.receipt_number
          request.value.requested_at = response.data.data.requested_at
          isRequestVoid.value = response.data.data.action === 'Void'
          isRequestCreate.value = response.data.data.action === 'Create'
          if (response.data.data.responded_by) isRespondedRequest.value = true
          if (response.data.data.approved_at) isApprovedRequest.value = true
        })
        .catch(error => {
          loading.value = false
          errors.value = error.response.data.errors
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching request. Please refresh!')
        })
    }
    const fetchRequestedBroker = () => {
      store
        .dispatch('requestStore/fetchRequest', { id: requestId })
        .then(response => {
          const returnedBroker = response.data.data.result

          broker.value.id = response.data.data.record.id
          broker.value.created_at = returnedBroker.created_at
          broker.value.name = returnedBroker.name
          broker.value.ic_number = returnedBroker.ic_number
          broker.value.contact_number = returnedBroker.contact_number
          broker.value.registration_date = new Date(returnedBroker.registration_date.replace(/(..)\/(..)\/(....)/, '$3-$2-$1')).toISOString().substring(0, 10)
          if (returnedBroker.ic_url) {
            broker.value.ic_url = returnedBroker.ic_url
            broker.value.ic_name = returnedBroker.ic_name
          }
          if (response.data.data.approved_at) isApprovedRequest.value = true
          broker.value.deleted_at = returnedBroker.deleted_at
          isRequestCreate.value = response.data.data.action === 'Create'
        })
        .catch(error => {
          loading.value = false
          errors.value = error.response.data.errors
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching request. Please refresh!')
        })
    }
    const fetchBroker = () => {
      store
        .dispatch('customerStore/fetchBroker', { id: router.currentRoute.params.id })
        .then(response => {
          const existingBroker = response.data.data

          broker.value.id = existingBroker.id
          broker.value.name = existingBroker.name
          broker.value.contact_number = existingBroker.contact_number
          broker.value.ic_number = existingBroker.ic_number
          broker.value.registration_date = new Date(existingBroker.registration_date.replace(/(..)\/(..)\/(....)/, '$3-$2-$1')).toISOString().substring(0, 10)
          broker.value.ic = existingBroker.ic
          broker.value.ic_url = existingBroker.ic_url
          broker.value.ic_name = existingBroker.ic_name
        })
        .catch(error => {
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching broker. Please refresh!')
        })
    }
    const updateBroker = (ic = null) => {
      delete broker.value.ic_url
      delete broker.value.ic_name
      if (ic) {
        broker.value.ic = ic.signed_id
      }
      const updateParam = {
        id: router.currentRoute.params.id,
        broker: broker.value,
      }
      store
        .dispatch('customerStore/updateBroker', updateParam)
        .then(response => {
          loading.value = false
          snackbarService.success(response.data.message)
          router.push('/apps/profile-creation/list')
        })
        .catch(error => {
          loading.value = false
          errors.value = error.response.data.errors
          snackbarService.error(error.response.data.message || 'Something went wrong while updating broker. Please refresh!')
        })
    }
    const saveRequest = (ic = null) => {
      loading.value = true
      delete broker.value.ic
      delete broker.value.ic_url
      delete broker.value.ic_name
      if (ic) {
        broker.value.ic = ic.signed_id
      }
      const requestParam = {
        record_id: broker.value.id,
        record_type: 'Broker',
        requested_by_id: userData.id,
        action: isRequestCreate.value ? 'Create' : 'Edit',
        params: broker.value,
        rejected_at: null,
        responded_by: null,
        comment: newComment.value,
      }
      if (ic) {
        requestParam.ic = ic.signed_id
      }
      if (requestId) requestParam.id = requestId

      store
        .dispatch(`requestStore/${requestId ? 'updateRequest' : 'createRequest'}`, requestParam)
        .then(response => {
          snackbarService.success(response.data.message)
          router.push('/apps/requests/list')
        })
        .catch(error => {
          loading.value = false
          isCommentDialogVisible.value = false
          errors.value = error.response.data.errors
          snackbarService.error(error.response.data.message || 'Something went wrong while saving request. Please refresh!')
        })
    }
    const approveRequest = () => {
      loading.value = true
      store
        .dispatch('requestStore/approveRequest', { id: requestId, comment: newComment.value })
        .then(response => {
          snackbarService.success(response.data.message)
          router.push('/apps/requests/list')
        })
        .catch(error => {
          loading.value = false
          errors.value = error.response.data.errors
          snackbarService.error(error.response.data.message || 'Something went wrong while approving request. Please refresh!')
        })
    }
    const rejectRequest = () => {
      loading.value = true
      store
        .dispatch('requestStore/rejectRequest', { id: requestId, comment: newComment.value })
        .then(response => {
          snackbarService.success(response.data.message)
          router.push('/apps/requests/list')
        })
        .catch(error => {
          loading.value = false
          errors.value = error.response.data.errors
          snackbarService.error(error.response.data.message || 'Something went wrong while rejecting request. Please refresh!')
        })
    }
    const voidRequest = () => {
      voidLoading.value = true
      store
        .dispatch('requestStore/voidRequest', { id: requestId })
        .then(response => {
          snackbarService.success(response.data.message)
          router.push('/apps/requests/list')
        })
        .catch(error => {
          voidLoading.value = false
          snackbarService.error(error.data.message || 'Something went wrong while voiding request. Please refresh!')
        })
    }
    const isNumber = event => {
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
      const keyPressed = event.key
      if (!keysAllowed.includes(keyPressed)) {
        event.preventDefault()
      }
    }
    const roleUpdate = role => {
      if (role === 'auditor') {
        updateBroker(uploadedIc.value)
      } else if (role === 'clerk') {
        saveRequest(uploadedIc.value)
      }
    }
    const directUploadIc = (file, role) => {
      uploadLoading.value = true
      store
        .dispatch('customerStore/directUploadIc', file)
        .then(response => {
          uploadLoading.value = false
          if (response) {
            uploadedIc.value = response
            roleUpdate(role)
          }
        })
        .catch(error => {
          uploadLoading.value = false
          snackbarService.error(error.response.data.message || 'Something went wrong while uploading IC. Please refresh!')
        })
    }
    const handleUploads = role => {
      const uploadFile = newIc.value
      if (uploadFile) directUploadIc(uploadFile, role)
      if (!newIc.value) roleUpdate(role)
    }
    const fetchComments = () => {
      store
        .dispatch('requestStore/fetchComments', { request_id: requestId })
        .then(response => {
          const { data } = response.data
          comments.value = data
        })
        .catch(error => {
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching comments. Please refresh!')
        })
    }
    const isBrokerEdit = () => {
      if (requestId && can('write', 'ReportActions')) {
        // Auditor view request
        auditorDisabled.value = true
        fetchRequest()
      } else if (router.currentRoute.params.action === 'Void') {
        voidRequestDisabled.value = true
        fetchRequest()
      } else if (requestId) {
        // Clerk edit request
        fetchRequestedBroker()
      } else {
        // Edit invoice / create request
        fetchBroker()
      }
    }

    // Mounted
    onMounted(() => {
      if (requestId) fetchComments()
      isBrokerEdit()
    })

    return {
      t,
      can,
      router,
      broker,
      request,
      requestId,
      comments,
      errors,
      fetchRequest,
      fetchRequestedBroker,
      saveRequest,
      voidRequest,
      approveRequest,
      rejectRequest,
      userData,
      dateToday,
      loading,
      isNumber,
      newIc,
      directUploadIc,
      handleUploads,
      uploadLoading,
      icUploadRules,
      isDateMenuOpen,
      isCommentDialogVisible,
      isVoidDialogVisible,
      isApproveDialogVisible,
      isRejectDialogVisible,
      newComment,
      fetchComments,
      fetchBroker,
      updateBroker,
      auditorDisabled,
      voidRequestDisabled,
      isApprovedRequest,
      isRespondedRequest,
      isRequestVoid,
      isRequestCreate,
      voidLoading,
      userRole,

      icons: {
        mdiCalendar,
        mdiPaperclip,
      },
    }
  },
}
</script>

<style lang="scss">
@import '~@core/preset/preset/apps/style.scss';

.app-invoice-editable {
  .invoice-add-branch {
    width: 15rem;
  }
}
</style>
